import * as Yup from 'yup';

export const seguimientoSchema = Yup.object({
    idAnuncio: Yup.number().min(1,'No se hace referencia a ningun anuncio'),
    txObservacion: Yup.string().min(2,'Minimo 2 caracteres').max(1000, 'Máximo 1000 caracteres').required('Requerido'),
});